<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">汇团团   社群团购小程序</div>
            <div class="banner_line"></div>
            <div class="banner_title2">帮助货源多的供货方，拓宽销路；帮助人脉广的团长，赚取佣金</div>
            <!-- <div class="banner_text">企业私域电商直播平台</div> -->
        </div>
        <img src="@/assets/Mobile/images/QcAssociation/banner.png" alt="">
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">您是否也为在以下痛点困扰？</div>
        </div>
        <div class="content" style="margin-top: 20px;">
            <img src="@/assets/Mobile/images/QcAssociation/programme1.png" alt="">
        </div>
      </div>
      <div class="tool">
        <div class="sk-mobile-title">
          <div class="title">操作步骤少，效率提升大</div>
        </div>
        <div class="content">
            <div class="content_btn">
                <div class="btn_top">
                    <div :class="tooItem=='1'?'btn_box1':'btn_box'" @click="checkBg('1')">
                        <div class="btn_line"></div>
                        <div class="btn_title">获流量</div>
                    </div>
                    <div :class="tooItem=='2'?'btn_box1':'btn_box'" @click="checkBg('2')">
                        <div class="btn_line"></div>
                        <div class="btn_title">找货源</div>
                    </div>
                    <div :class="tooItem=='3'?'btn_box1':'btn_box'" @click="checkBg('3')">
                        <div class="btn_line"></div>
                        <div class="btn_title">拓销路</div>
                    </div>
                </div>
                <div class="btn_bottom" v-if="tooItem=='1'">
                    <ul>
                        <li><span>社群跟团分享，营造接龙火爆气氛</span></li>
                        <li><span>多人拼团商品低价，吸引流量</span></li>
                    </ul>
                </div>
                <div class="btn_bottom" v-if="tooItem=='2'">
                    <ul>
                        <li><span>官方供应链资源支撑，品牌直供、正品保障</span></li>
                        <li><span>优质供货团长一手货源入驻，高额利润，独家资源</span></li>
                    </ul>
                </div>
                <div class="btn_bottom" v-if="tooItem=='3'">
                    <ul>
                        <li><span>全平台团长帮卖，实现业绩增长</span></li>
                        <li><span>一键复制帮卖，推荐赚佣金</span></li>
                    </ul>
                </div>
            </div>
            <div class="content_bg">
                <img v-if="tooItem=='1'" src="@/assets/Mobile/images/QcAssociation/content_right1.png" alt="">
                <img v-if="tooItem=='2'" src="@/assets/Mobile/images/QcAssociation/content_right2.png" alt="">
                <img v-if="tooItem=='3'" src="@/assets/Mobile/images/QcAssociation/content_right3.png" alt="">
            </div>
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">供货团长，通过帮卖裂变和社群自买，实现增客流和促成交！</div>
        </div>
        <div class="content" style="margin-top: 32px;">
            <img src="@/assets/Mobile/images/QcAssociation/programme2.png" alt="">
        </div>
      </div>
      <div class="programme programme4">
        <div class="sk-mobile-title">
          <div class="title">想赚钱，想省钱都来汇团团</div>
        </div>
        <div class="content" style="margin-top: 20px;">
            <img src="@/assets/Mobile/images/QcAssociation/programme3.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="汇团团" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="汇团团" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcAssociation,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .tool{
    background: #F9FFFB;
    padding:0 16px;
    .content{
        display: flex;
        flex-direction: column;
        align-items: center;
        .content_btn{
            width: 328px;
            height: 73px;
            margin-top: 7px;
            .btn_top{
                height:32px;
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                .btn_box{
                    width: 102px;
                    height: 32px;
                    background: #F0F0F0;
                    border-radius: 8px 8px 0px 0px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    .btn_line{
                        width: 3px;
                        height: 9px;
                        background: #CCCCCC;
                        border-radius: 2px;
                    }
                    .btn_title{
                        font-size: 12px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        color: #999999;
                        line-height: 32px;
                        margin-left: 4px;
                    }
                }
                .btn_box1{
                    width: 102px;
                    height: 32px;
                    background: #EAF9EF;
                    border-radius: 8px 8px 0px 0px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    .btn_line{
                        width: 3px;
                        height: 9px;
                        background: #60BC66;
                        border-radius: 2px;
                    }
                    .btn_title{
                        font-size: 12px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 32px;
                        margin-left: 4px;
                    }
                }
            }
            .btn_bottom{
                height:69px;
                width: 328px;
                padding:12px 13px;
                background: #EAF9EF;
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 17px;
                text-align: left;
                ul{
                    padding-left:8px;
                    li{
                        list-style:disc;
                        color:#05AA5C;
                        margin-bottom:8px;
                        span{
                            font-size: 11px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }
                    }
                }
            }
        }
        .content_bg{
            height:253px;
            margin-top: 30px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
  }
  .programme1{
    background: #FFFFFF;
  }
  .programme2{
    background: #F8FCFF;
  }
  .programme3{
    background: #F8FBFF;
  }
  .programme4{
    background: #F8FBFD;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 22px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  